// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('checkListItemTws', {
//         templateUrl: 'views/components/views/checkListItemTws/checkListItemTws.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'checkListItemTwsService', function ($stateParams, stateService, utilityService, checkListItemTwsService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let argType = $stateParams.argtype;
//             let argValue = $stateParams.argvalue;

//             vm.model = {
//                 setting: {},
//                 itemsListLinksToForms: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await checkListItemTwsService.getLinkToForm({
//                     argtype: argType,
//                     argvalue: argValue
//                 }))[0];
//             }
            
//             async function loadLinksToForms() {
//                 if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;

//                 return vm.model.itemsListLinksToForms = await checkListItemTwsService.listLinksToForms({
//                     argtype: vm.model.setting.argtype,
//                     argvalue: vm.model.setting.argvalue
//                 });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region MULTI DIRECTION BUTTON FUNCTIONS

//             vm.goToFunc = function (state, e) {
//                 function go(parms) {
//                     if (e?.ctrlKey) {
//                         stateService.newTab(state, parms);
//                     } else {
//                         stateService.go(state, parms);
//                     }
//                 }

//                 switch (state) {
//                     case 'checklistitemtw':
//                         go({
//                             argtype: vm.model.setting.argtype,
//                             argvalue: vm.model.setting.argvalue,
//                             checklistitemtw_keyno: '0'
//                         });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadLinksToForms();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
